import { makeStyles, Theme } from '@material-ui/core/styles'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import React from 'react'
import ChevronDownIcon from './ChevronDownIcon'

const useStyles = makeStyles((theme: Theme) => ({
    // No pill chrome — label + chevron sit flush on the header background,
    // matching the avatar's borderless treatment.
    pill: {
        height: pxToRem(34),
        padding: `0 ${pxToRem(12)} 0 ${pxToRem(10)}`,
        marginLeft: pxToRem(4),
        display: 'flex',
        alignItems: 'center',
        gap: pxToRem(8),
        color: theme.harmony.colors.textHeader,
        cursor: 'default',
    },
    label: {
        ...theme.harmony.typography.tabLabel,
        whiteSpace: 'nowrap',
    },
    chevron: {
        width: pxToRem(14),
        height: pxToRem(14),
        color: theme.harmony.colors.textParagraph,
        flexShrink: 0,
    },
}))

export interface ContextPillProps {
    /** Short workspace-mode label, e.g. "(A/E)" or "(OM)". */
    modeLabel: string
    userName: string
}

/**
 * Static Harmony context pill — the design prototype itself has this unwired (no
 * dropdown menu), so this is a presentational-only display of the current mode + user.
 */
const ContextPill = ({ modeLabel, userName }: ContextPillProps) => {
    const classes = useStyles()

    return (
        <div className={classes.pill} data-testid="contextPill">
            <span className={classes.label}>
                {modeLabel} &middot; {userName}
            </span>
            <ChevronDownIcon className={classes.chevron} />
        </div>
    )
}

export default ContextPill
